import React, { useState, useEffect } from "react";
import "./Login.css";
import { useNavigate } from "react-router-dom";
import { useForgotPassword } from "../../hooks/useForgotPassword"; 

function ForgotPass() {
  const [email, setEmail] = useState("");
  const { sendRecoveryEmail, success, loading, error } = useForgotPassword();
  const navigate = useNavigate();
  const [validationError, setValidationError] = useState(null); // novo estado para erro de validação

  // Função que valida o email
  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleEnviar = () => {
    // Checa se o email é válido
    if (!isValidEmail(email)) {
      setValidationError("Email inválido.");
      return;
    }

    setValidationError(null); // limpa o erro se estiver tudo certo
    sendRecoveryEmail({ email });
  };

  useEffect(() => {
    if (success) {
      alert("Email de recuperação enviado!");
      navigate("/login"); 
    }
  }, [success, navigate]);

  return (
    <div className="login-container">
      <img src="imgs/reino_header_logo.svg" alt="Reinoplay Logo" className="login-logo" />
      <p style={{ color: "#fff", marginBottom: 10 }}>
        Digite o email para atualizar senha
      </p>
      <input
        type="email"
        placeholder="Email"
        className="login-input"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        style={{ padding: 10 }}
      />
      {/* Mensagem de erro por validação de email */}
      {validationError && <p style={{ color: "orange", marginTop: 10 }}>{validationError}</p>}

      {/* Mensagem de erro vinda do hook */}
      {error && <p style={{ color: "red", marginTop: 10 }}>{error}</p>}

      <button className="login-button" onClick={handleEnviar} disabled={loading}>
        {loading ? "Enviando..." : "Enviar"}
      </button>
    </div>
  );
}

export default ForgotPass;
